import List from '../core/List';
import Resource from './Resource';

class ResourceList extends List {
  constructor(args= {}) {
    const {
      data = null,
    } = args;

    // "data" might be passe down as null from the server (IE. in case of delete)
    // We need to default both null and undefined to the empty array.
    const dataArg = data || [];

    const resourceData = Array.isArray(dataArg) ? dataArg : [dataArg]; // Everything is a list.

    super({
      ...args,
      data: resourceData.map(v => new Resource({
        ...args,
        data: v,
      })),
    });

    // This must be called for every List implementation.
    this.list().map(v => v.parent(this));
  }

  // https://jsonapi.org/format/#document-resource-identifier-objects
  findResource(resourceIdentifierObject) {
    if(!resourceIdentifierObject) {
      return null;
    }
    return this.findItem(r => r.id() === resourceIdentifierObject.id && r.type() === resourceIdentifierObject.type )
  }
}

export default ResourceList;
